<template>
	<div>this is dashboard</div>
</template>

<script>
export default {
	name: 'DashboardView',
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/DashboardView.vue